// File size limits in bytes
const MB = 1024 * 1024;

const UPLOAD = {
  MAX_IMAGE_SIZE: 50 * MB,
  MAX_VIDEO_SIZE: 100 * MB,
  MAX_AUDIO_SIZE: 16 * MB,
  MAX_DOCUMENT_SIZE: 100 * MB,

  // Image compression settings
  COMPRESS_MAX_DIMENSION: 1920,
  COMPRESS_QUALITY: 0.8,
  COMPRESS_SKIP_UNDER: 200 * 1024, // 200 KB

  labels: {
    image: "50 MB",
    video: "100 MB",
    audio: "16 MB",
    document: "100 MB",
  },

  getLimit(fileType: string): {
    limit: number;
    label: string;
    category: string;
  } {
    if (fileType.startsWith("image/"))
      return {
        limit: UPLOAD.MAX_IMAGE_SIZE,
        label: UPLOAD.labels.image,
        category: "Image",
      };
    if (fileType.startsWith("video/"))
      return {
        limit: UPLOAD.MAX_VIDEO_SIZE,
        label: UPLOAD.labels.video,
        category: "Video",
      };
    if (fileType.startsWith("audio/"))
      return {
        limit: UPLOAD.MAX_AUDIO_SIZE,
        label: UPLOAD.labels.audio,
        category: "Audio",
      };
    return {
      limit: UPLOAD.MAX_DOCUMENT_SIZE,
      label: UPLOAD.labels.document,
      category: "File",
    };
  },
};

export default UPLOAD;
